// removed by extract-text-webpack-plugin
module.exports = {"root":"UlV3V","disabled":"_24CzY","input":"_28hit","fakeInput":"_39Cq6","checkbox":"Qpwt6","checked":"_1HqOv","radio":"_1tvOp","label":"_2Af26","required":"LSRlj","error":"_2ls-d","description":"_3Exwf"};


//////////////////
// WEBPACK FOOTER
// ../source/components/Switch/styles.css
// module id = 1294
// module chunks = 7 8 11